import { render, staticRenderFns } from "./ProformCategoryTable.vue?vue&type=template&id=0821c8f1&scoped=true"
import script from "./ProformCategoryTable.vue?vue&type=script&lang=js"
export * from "./ProformCategoryTable.vue?vue&type=script&lang=js"
import style0 from "./ProformCategoryTable.vue?vue&type=style&index=0&id=0821c8f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0821c8f1",
  null
  
)

export default component.exports